/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import { Tag, Typography2 } from '@coursera/cds-core';

import { MIN_NUM_OF_SKILLS_TO_SHOW } from 'bundles/enterprise-legacy-learner-home/constants/xdpConstants';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

const styles = {
  container: css`
    border-radius: var(--cds-border-radius-100);
  `,
  title: css`
    margin-bottom: var(--cds-spacing-200);
  `,
  skillsList: css`
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: var(--cds-spacing-100);
    padding: 0;
    margin: 0;
  `,
};

type Props = {
  sectionTitle?: string;
  skills?: Array<string>;
  titleTag?: React.ElementType;
  cssOverrides?: SerializedStyles;
};

export default function Skills({
  skills = [],
  sectionTitle = _t('Skills you will gain'),
  titleTag = 'h2',
  cssOverrides,
}: Props) {
  if (skills.length < MIN_NUM_OF_SKILLS_TO_SHOW) return null;

  return (
    <div
      className="Skills skills-combined-with-learning-objs"
      css={[styles.container, cssOverrides]}
      data-testid="skills"
    >
      <Typography2 component={titleTag} variant="bodySecondary" css={styles.title}>
        {sectionTitle}
      </Typography2>
      {/* safari loses semantics when list-style is none https://www.scottohara.me/blog/2019/01/12/lists-and-safari.html */}
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul role="list" css={styles.skillsList}>
        {skills.map((skill) => (
          <li key={`${skill}-item`}>
            <Tag>{skill}</Tag>
          </li>
        ))}
      </ul>
    </div>
  );
}
